import { Article } from '@ahc-digital/component-library';
import { GetArticleBaseModel } from 'src/shared/ArticleBase.service';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { useCustomSitecoreContext } from 'src/shared/useCustomSitecoreContext';
import { translationClasses } from 'src/shared/TranslationClasses';
import { C60NewsDetailsProps } from './C60NewsDetails.types';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { useUpdateEmailShareLink } from 'src/shared/useUpdateEmailShareLink';

export const Default = (props?: C60NewsDetailsProps): JSX.Element => {
  const context = useCustomSitecoreContext();
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  const headline = props?.rendering?.fields?.Headline?.value ?? '';
  useUpdateEmailShareLink(headline);

  if (!props?.rendering?.dataSource) {
    return <PromptForMissingDatasource rendering={props?.rendering} />;
  }

  return (
    <Article
      id={props?.params?.AnchorLinkTargetName}
      {...GetArticleBaseModel(props?.fields, context?.socialMediaLinks?.value || [])}
      className={translationClasses(props.params)}
      data-component={marketingRenderingName}
    />
  );
};
